
<div>
  <header v-if="showTitle" class="hero_container green" style="min-height: 140px;">
    <div class="container-fluid">
      <h1 style="padding-top: .5rem;">{{headerTitle}}</h1>
    </div>
  </header>

  <application :user="Selected.currentUser.get()" :header-attrs="headerAttrs" has-footer class="model-views app-content">
    <template #header>
      <div class="page-title">
        <h1>{{headerTitle}}</h1>
      </div>
    </template>

    <template #secondary-header>
      <router-view name="secondaryHeader" :breadcrumbs="breadcrumbs" ref="secondaryHeader"></router-view>
    </template>

    <main class="main-content">
      <router-view
        @queue-upload-for-deletion="queueUploadForDeletion($event)"
      ></router-view>
    </main>
  </application>
</div>
